module.exports = __webpack_public_path__ + "static/media/Passport_ex.fe2512c3.jpg";